<div *ngIf="apiLoaded" class="container" #mapContainer>
  <google-map #googleMap [options]="mapOptions" width="100%" height="100%">
    <map-marker
      [position]="currentUserMarker.position"
      [options]="currentUserMarker"
    ></map-marker>
    <map-marker
      #establishmentMapMarker="mapMarker"
      *ngFor="let establishmentMarker of establishmentMarkers"
      [position]="establishmentMarker.marker.position"
      [options]="establishmentMarker.marker"
      (mapClick)="
        openInfoWindow(establishmentMapMarker, establishmentMarker.restaurant)
      "
    >
    </map-marker>
    <map-marker
      #motoristaMapMarker="mapMarker"
      *ngFor="let motoristaMarker of motoristaMarkers"
      [position]="motoristaMarker.marker.position"
      [options]="motoristaMarker.marker"
      class="mapado"
    ></map-marker>
    <div class="map-controls">
      <div class="control-btn" (click)="recenterMap()">
        <ion-icon name="navigate"></ion-icon>
      </div>
      <div class="control-btn" (click)="zoomIn()">
        <ion-icon name="add"></ion-icon>
      </div>
      <div class="control-btn" (click)="zoomOut()">
        <ion-icon name="remove"></ion-icon>
      </div>
    </div>

    <map-directions-renderer
      *ngIf="directionsResults$ | async as directionsResults"
      [directions]="directionsResults"
      [options]="directionOptions"
    ></map-directions-renderer>
  </google-map>
</div>
<ion-modal #modal *ngIf="selectedRestaurant" class="establishment-modal">
  <ng-template>
    <ion-content style="--background: white">
      <ion-toolbar>
        <ion-buttons slot="end">
          <ion-button color="primary" (click)="closeModal()"
            ><ion-icon name="close-circle"></ion-icon
          ></ion-button>
        </ion-buttons>
      </ion-toolbar>
      <ion-card *ngIf="selectedRestaurant" class="establishment-card">
        <ion-card-header class="establishment-header">
          <ion-img
            [src]="selectedRestaurant.icone"
            class="establishment-img"
          ></ion-img>
          <ion-card-title class="title">
            {{ selectedRestaurant.nomeRestaurante }}</ion-card-title
          >
          <ion-card-subtitle
            class="subtitle"
            *ngIf="selectedRestaurant.tipoCozinha"
            >{{ selectedRestaurant.tipoCozinha.nome }}</ion-card-subtitle
          >
          <ion-card-subtitle class="subtitle">{{
            selectedRestaurant.tipoEstabelecimento
          }}</ion-card-subtitle>
          <ion-card-subtitle class="subtitle">{{
            selectedRestaurant.endereco
          }}</ion-card-subtitle>
          <ion-card-subtitle class="subtitle">{{
            selectedRestaurant.telefone
          }}</ion-card-subtitle>
        </ion-card-header>
        <ion-card-content class="establishment-card-content">
          <span class="price">{{ selectedRestaurant.preco }}</span>
          <div class="chips">
            <ion-chip *ngFor="let servico of selectedRestaurant.servicos">
              <small>{{ getServiceDescription(servico) }}</small>
            </ion-chip>
          </div>
          <div class="flags">
            <ion-img
              *ngIf="selectedRestaurant.idiomas?.includes(Languages.English)"
              src="assets/English.svg"
              class="ico"
              alt=""
            />
            <ion-img
              *ngIf="selectedRestaurant.idiomas?.includes(Languages.Portuguese)"
              src="assets/Portuguese.svg"
              class="ico"
              alt=""
            />
            <ion-img
              *ngIf="selectedRestaurant.idiomas?.includes(Languages.Spanish)"
              src="assets/Spanish.png"
              class="ico"
              alt=""
            />
            <ion-img
              *ngIf="selectedRestaurant.idiomas?.includes(Languages.Mandarin)"
              src="assets/Mandarin.png"
              class="ico"
              alt=""
            />
            <ion-img
              *ngIf="selectedRestaurant.idiomas?.includes(Languages.French)"
              src="assets/French.png"
              class="ico"
              alt=""
            />
            <ion-img
              *ngIf="selectedRestaurant.idiomas?.includes(Languages.Italian)"
              src="assets/Italian.png"
              class="ico"
              alt=""
            />
            <ion-img
              *ngIf="selectedRestaurant.idiomas?.includes(Languages.Japanese)"
              src="assets/Japanese.png"
              class="ico"
              alt=""
            />
            <ion-img
              *ngIf="selectedRestaurant.idiomas?.includes(Languages.Arabic)"
              src="assets/Arabic.png"
              class="ico"
              alt=""
            />
            <ion-img
              *ngIf="selectedRestaurant.idiomas?.includes(Languages.German)"
              src="assets/German.png"
              class="ico"
              alt=""
            />
            <ion-img
              *ngIf="selectedRestaurant.idiomas?.includes(Languages.Russian)"
              src="assets/Russian.png"
              class="ico"
              alt=""
            />
            <ion-img
              *ngIf="selectedRestaurant.idiomas?.includes(Languages.Vietnamese)"
              src="assets/Vietnamese.png"
              class="ico"
              alt=""
            />
          </div>
        </ion-card-content>
        <ion-card-content>
          <app-reservation-form
            [showHeader]="false"
            [contentDisplayType]="'contents'"
            [selectedRestaurantDashboard]="selectedRestaurant"
          ></app-reservation-form>
        </ion-card-content>
      </ion-card>
    </ion-content>
  </ng-template>
</ion-modal>
